import config from 'config';

export function getExternalLoginUrl(returnPath?: string): string {
  const url = new URL('/login', config.COGNITO.externalAuthUrl);
  url.searchParams.set('origin', window.location.origin);
  if (returnPath) {
    url.searchParams.set('returnPath', returnPath);
  }
  return url.toString();
}

export function getExternalRegistrationUrl(returnPath?: string): string {
  const url = new URL('/register', config.COGNITO.externalAuthUrl);
  url.searchParams.set('origin', window.location.origin);
  if (returnPath) {
    url.searchParams.set('returnPath', returnPath);
  }
  return url.toString();
}
